export interface Product {
  id: string
  name: string
  price: number
  description: string
  features: string[]
  image: string
  category: 'unit' | 'kit' | 'part'
}

export const products: Product[] = [
  {
    id: 'pro-sprayer-complete',
    name: 'Precision Pro Electric Sprayer (Complete Unit)',
    price: 599,
    description:
      'The ultimate industrial electric sprayer for mold remediation and water restoration. Cut your job time in half with consistent pressure and zero pumping.',
    features: [
      'Continuous 60 PSI pressure',
      '8-hour battery life',
      'Chemical resistant seals',
      '40-foot reinforced hose',
      'Includes heavy-duty wand',
    ],
    image:
      'https://images.unsplash.com/photo-1581092334651-ddf26d9a09d0?auto=format&fit=crop&q=80&w=800',
    category: 'unit',
  },
  {
    id: 'pro-sprayer-kit',
    name: 'Precision Pro DIY Kit',
    price: 399,
    description:
      'Build your own professional sprayer. Includes pump, battery, wand, and hose. You supply the tank and case.',
    features: [
      'High-performance pump motor',
      'Rechargeable battery pack',
      'Professional spray wand',
      'Wiring harness included',
      'Assembly instructions',
    ],
    image:
      'https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=800',
    category: 'kit',
  },
  {
    id: 'replacement-wand',
    name: 'Heavy Duty Spray Wand',
    price: 89,
    description: 'Replacement stainless steel wand with adjustable nozzle.',
    features: [
      'Stainless steel construction',
      'Adjustable brass nozzle',
      'Ergonomic grip',
    ],
    image:
      'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?auto=format&fit=crop&q=80&w=800',
    category: 'part',
  },
  {
    id: 'replacement-hose',
    name: '40ft Reinforced Hose',
    price: 65,
    description: 'Extra long hose to reach anywhere without moving the unit.',
    features: ['40 foot length', 'Kink-resistant', 'Chemical resistant'],
    image:
      'https://images.unsplash.com/photo-1563298723-dcfebaa392e3?auto=format&fit=crop&q=80&w=800',
    category: 'part',
  },
]
